import { ElementRef, Injectable } from '@angular/core';
import { FormBuilderUDFService } from './services/form-builder-udf-service';
import { FormViewerInterface } from './shared/drag-drop-content/interfaces/form-viewer.interface';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedOperationService {

  private formViewerSource = new BehaviorSubject<FormViewerInterface>({
    json_data: null,
    html_data: null,
    container: null,
    renderer: null,
  });
  formViewerData$ = this.formViewerSource.asObservable();
  dataFromShared: any;

  setFormViewerData(data: FormViewerInterface) {
    this.formViewerSource.next(data);
  }
  constructor(private formService: FormBuilderUDFService) {
    this.formViewerData$.subscribe((data) => {
      if (data) {
        this.dataFromShared = data;
      }
    });
   }

   async fetchDataFromAPI(params: any, url: string, requestType: string, apiDirectoryId?: number, isExternalAPI?: boolean): Promise<any> {
    if (apiDirectoryId && isExternalAPI !== false) {
      try {
        return await this.formService.callExternalAPI(apiDirectoryId, params).toPromise();
      } catch (error) {
        console.error('Error calling external API proxy', error);
        throw error;
      }
    }
    if (url === 'FormBuilder/fetchFormData') {
      params.pageId = localStorage.getItem('O3RightMenuId');
    }
    try {
      const observable = this.formService.getDataFromAPI(params, url, requestType);
      if (!observable) {
        throw new Error('getDataFromAPI returned undefined');
      }
      const result = await observable.toPromise();
      localStorage.removeItem('pageId');
      return result;
    } catch (error) {
      console.error('Error fetching data from API', error);
      throw error;
    }
  }

  constructDependentParams(dependentDropdownName: string, container: HTMLElement, getDropdownConfig: Function): any {
    const paramData: { [key: string]: any } = {};
    const elementConfig = getDropdownConfig(dependentDropdownName);
    if (elementConfig) {
      const params = JSON.parse(elementConfig.element.datasourceParamaters);
      if (Array.isArray(params)) {
        params.forEach((obj: any) => {
          Object.entries(obj).forEach(([key, value]) => {
            paramData[key] = `${this.getSelectedValue(value as string, container)}`;
          });
        });
      } else if (typeof params === 'object' && params !== null) {
        Object.entries(params).forEach(([key, value]) => {
          paramData[key] = `${this.getSelectedValue(value as string, container)}`;
        });
      } else {
        console.error('Invalid datasource parameters structure:', params);
      }
    }
    return paramData;
  }

  getSelectedValue(fieldName: string, container: HTMLElement): string | any {
    let field: HTMLElement | null = null;
  
    //here define all posible elements 
    const selectors = [
      `select[name="${fieldName}"]`,
      `input[name="${fieldName}"]`,
      `textarea[name="${fieldName}"]`,
      `button[name="${fieldName}"]`,
      `datalist[name="${fieldName}"]`,
      `output[name="${fieldName}"]`
    ];
  
    for (const selector of selectors) {
      field = container === undefined ? this.dataFromShared?.container.nativeElement .querySelector(selector) : container.querySelector(selector);
      if (field) break;
    }
  
    if (field) {
      if (field instanceof HTMLSelectElement) {
        return field.value !== null ? field.value : 0;
      } else if (field instanceof HTMLInputElement) {
        if (field.type === 'checkbox' || field.type === 'radio') {
          return field.checked ? field.value : 0;
        }
        return field.value !== null ? field.value : 0;
      } else if (field instanceof HTMLTextAreaElement) {
        return field.value !== null ? field.value : 0;
      } else if (field instanceof HTMLButtonElement) {
        return field.value !== null ? field.value : 0;
      } else if (field instanceof HTMLDataListElement) {
        return field.innerHTML !== null ? field.innerHTML : 0;
      } else if (field instanceof HTMLOutputElement) {
        return field.value !== null ? field.value : 0;
      }
    }
  
    // If no field is found, return 0 or a default value razique
    return 0;
  }



  getFormValues(el: ElementRef): any {
    type FormValue = string | { value: any; text: any };
    const formElement = el.nativeElement.querySelector('form');
    const formValues: { [key: string]: FormValue } = {};

    if (formElement) {
      const inputs = formElement.querySelectorAll('input, select, textarea');
      inputs.forEach((input: any) => {
        const name = input.name;
        let value: FormValue = '';

        if (input.type === 'radio' && input.checked) {
          value = input.value;
        } else if (input.type === 'checkbox') {
          value = input.checked.toString();
        } else if (input.tagName.toLowerCase() === 'select') {
          value = {
            value: input.value,
            text: input.options[input.selectedIndex].text
          };
        } else if (input.type !== 'radio') {
          value = input.value;
        }

        if (name && value !== '') {
          formValues[name] = value;
        }
      });
    }

    return formValues;
  }

  initializePlugins() {
    if (typeof $ !== 'undefined') {
      $(document).ready(() => {
        $('div[id^="datetime_input_"]').each(function() {
          $(this).datetimepicker({
            format: "YYYY-MM-DD HH:mm:ss",
            focusOnShow: false,
            defaultDate: new Date(), // Set current datetime as default value
            icons: {
              time: 'far fa-clock',
              date: 'far fa-calendar',
              up: 'fas fa-arrow-up',
              down: 'fas fa-arrow-down',
              previous: 'fas fa-chevron-left',
              next: 'fas fa-chevron-right',
              today: 'far fa-calendar-check-o',
              clear: 'far fa-trash',
              close: 'far fa-times'
            }
          });
        });
        // Initialize other plugins if necessary
      });
    } else {
      console.error('jQuery is not loaded');
    }
  }

}
